<template>
    <div class="initial-review">
        <SetDetails :mode="mode" :set="set" />
        <div class="action-btns">
            <button @click="btnFns.acceptConfirmation" class="accept-btn">Accept</button>
            <button @click="btnFns.rejectConfirmation" class="decline-btn">Decline</button>
            <button @click="btnFns.messageVenue" class="message-btn">Message</button>
        </div>
    </div>
</template>
<script>
    import reviewSetCmpntAndProps from '@/mixins/review-set'

    export default {
        name: 'InitialReview',
        mixins: [reviewSetCmpntAndProps]
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../../sass/_variables.scss';
    .initial-review {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 40px;

        .action-btns {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-self: center;
            gap: 8px;

            .accept-btn,
            .decline-btn,
            .message-btn {
                width: 100%;
                display: flex;
                padding: 12px 32px;
                justify-content: center;
                align-items: center;
                border-radius: 120px;
                font-family: 'Instrument Sans';
                font-size: 18px;
                font-style: normal;
                font-weight: 500;
                line-height: 133%;

                @media screen and (max-width: 768px) {
                    padding: 6px 16px;
                }
            }
            .accept-btn {
                background: #cdeb09;
                color: #000;
            }
            .decline-btn,
            .message-btn {
                background: inherit;
                color: #cdeb09;
                border: 1px solid #cdeb09;
            }
        }
    }
</style>
